import { useQuery } from '@tanstack/react-query';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import { customFetcher } from '../useFetch';
import { IUser, IUserFullObject } from '../../Interfaces/IUser';

export const useGetUserFullObject = (idUser?: number) => {
  const {
    data: userFullObject,
    isLoading: isLoadingUserFullObject,
    refetch: refetchUserFullObject,
  } = useQuery<IUserFullObject>({
    queryKey: ['user', idUser],
    queryFn: () => customFetcher({ endpoint: `/user/${idUser}` }),
    enabled: !!idUser,
  });

  return { userFullObject, isLoadingUserFullObject, refetchUserFullObject };
};

export const useGetUserGroups = () => {
  const {
    data: userGroups,
    isLoading: isLoadingUserGroups,
    refetch: refetchUserGroups,
  } = useQuery<IUserGroup[]>({
    refetchOnWindowFocus: false,
    queryKey: ['usergroup'],
    queryFn: () => customFetcher({ endpoint: '/usergroup' }),
  });

  return { userGroups, isLoadingUserGroups, refetchUserGroups };
};

export const useGetUsers = () => {
  const {
    data: users,
    isLoading: isLoadingUsers,
    refetch: refetchUsers,
  } = useQuery<IUser[]>({
    refetchOnWindowFocus: false,
    queryKey: ['userlist'],
    queryFn: () => customFetcher({ endpoint: '/userlist' }),
  });

  return { users, isLoadingUsers, refetchUsers };
};
